import azureConfig from "./azure-exports";
const msalConfig = {
  auth: {
    clientId: azureConfig.azureClientId, // This is the ONLY mandatory field; everything else is optional.
    authority: azureConfig.signUpSignIn.authority, // Choose sign-up/sign-in user-flow as your default.
    knownAuthorities: [azureConfig.authorityDomain], // You must identify your tenant's domain as a known authority.
    redirectUri: "https://dev.plus.delaval.cloud", // You must register this URI on Azure Portal/App Registration. Defaults to "window.location.href".
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false, // If you wish to store cache items in cookies as well as browser cache, set this to "true".
  },
};
export default msalConfig;
